
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.24.28c2.09 0 2.53.02 3.6.07 1.25.06 2.1.26 2.85.55.77.3 1.43.7 2.08 1.35.65.65 1.05 1.31 1.35 2.08.29.75.49 1.6.55 2.85l.03.6.01.19.01.19c.02.69.03 1.47.03 3.33v1.07c0 2.7-.02 3.13-.07 4.3-.06 1.25-.26 2.1-.55 2.85-.3.77-.7 1.43-1.35 2.08-.65.65-1.31 1.05-2.08 1.35-.75.29-1.6.49-2.85.55-1.18.05-1.6.07-4.3.07h-1.07c-1.86 0-2.64-.01-3.33-.03l-.19-.01-.19-.01-.6-.03c-1.25-.06-2.1-.26-2.85-.55-.77-.3-1.43-.7-2.08-1.35A5.774 5.774 0 01.89 19.7C.6 18.95.4 18.1.34 16.85c-.05-1.07-.07-1.52-.07-3.6v-2.47c0-2.09.02-2.53.07-3.6.06-1.25.26-2.1.55-2.85.3-.77.7-1.43 1.35-2.08C2.89 1.6 3.55 1.2 4.32.9 5.07.61 5.92.41 7.17.35 8.24.3 8.69.28 10.77.28h2.47zM12 2.39h-1c-1.49 0-2.17.01-2.79.03l-.18.01c-.24.01-.49.02-.78.03-1.14.05-1.77.24-2.18.4-.55.21-.94.47-1.35.88-.41.41-.66.8-.88 1.35-.16.41-.35 1.03-.4 2.18-.01.29-.02.53-.03.78l-.01.18c-.02.61-.03 1.3-.03 2.79v2c0 2.24.02 2.65.07 3.74.05 1.14.24 1.77.4 2.18.21.55.47.94.88 1.35.41.41.8.66 1.35.88.41.16 1.03.35 2.18.4 1.13.05 1.54.07 3.97.07h1.53c2.44 0 2.85-.02 3.97-.07 1.14-.05 1.77-.24 2.18-.4.55-.21.94-.47 1.35-.88.41-.41.66-.8.88-1.35.16-.41.35-1.03.4-2.18.05-1.13.07-1.54.07-3.97v-1.53c0-1.65-.01-2.37-.03-3.01l-.01-.18c-.01-.24-.02-.49-.03-.78-.05-1.14-.24-1.77-.4-2.18-.21-.55-.47-.94-.88-1.35-.41-.41-.8-.66-1.35-.88-.41-.16-1.03-.35-2.18-.4-1.09-.05-1.51-.06-3.74-.07h-.73L12 2.39zm0 3.6a6.03 6.03 0 110 12.062A6.03 6.03 0 0112 5.99zm0 2.11a3.91 3.91 0 100 7.82 3.91 3.91 0 100-7.82zm6.26-3.76c.78 0 1.41.63 1.41 1.41s-.63 1.41-1.41 1.41c-.78 0-1.41-.63-1.41-1.41s.63-1.41 1.41-1.41z","fill-rule":"evenodd","clip-rule":"evenodd"}})])
          )
        }
      }
    